import React from "react";
import { Modal, ModalHeader, ModalBody, ModalFooter } from "reactstrap";
import "../../scss/shared/_modal.scss";

const CustomModal = ({
  size,
  ariaLabelBy,
  bodyClass,
  buttonText,
  className,
  modalHeader,
  customHeader,
  external,
  modalIsOpen,
  handleClose,
  handleSave,
  children,
  backdrop,
}) => {
  return (
    <div>
      <Modal
        labelledBy={ariaLabelBy}
        fade={false}
        centered
        size={size}
        isOpen={modalIsOpen}
        toggle={handleClose}
        className={"modal_close_button " + className}
        external={external}
        backdrop={backdrop ?? true}
      >
        {!external && !customHeader && (
          <ModalHeader
            toggle={handleClose}
            className={modalHeader ? null : "empty"}
          >
            {modalHeader && (
              <div>
                <h4>{modalHeader}</h4>
                <div className="dyna-divider dyna-divider-darkbg"></div>
              </div>
            )}
          </ModalHeader>
        )}
        {customHeader}
        <ModalBody className={bodyClass}>{children}</ModalBody>
        {buttonText && (
          <ModalFooter>
            <button className="dyna-btn" onClick={handleSave}>
              {buttonText}
            </button>
          </ModalFooter>
        )}
      </Modal>
    </div>
  );
};

export default CustomModal;
